import Vue from 'vue';
import VueRouter from 'vue-router';
import CorporationsView from '../views/CorporationsView.vue';
import CorporationView from '../views/CorporationView.vue';
import ShopCreateView from '../views/shop/ShopCreateView.vue';
import ShopsView from '../views/shop/ShopsView.vue';
import ShopView from '../views/shop/ShopView.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/corporations'
  },
  {
    path: '/corporations',
    name: 'CorporationsList',
    meta: {
      title: 'Корпорации',
    },
    component: CorporationsView
  },
  {
    path: '/corporations/:corporation_id',
    name: 'Corporation',
    meta: {
      title:'Корпорация'
    },
    props: true,
    component: CorporationView
  },
  {
    path: '/shops',
    name: 'Shops',
    meta: {
      title: 'Магазины',
    },
    component: ShopsView
  },
  {
    path: '/shops/add',
    name: 'ShopCreate',
    meta: {
      title: 'Добавление магазина',
    },
    props: true,
    component: ShopCreateView
  },
  {
    path: '/shops/:shop_id/edit',
    name: 'ShopEdit',
    meta: {
      title: 'Редактирование магазина',
    },
    props: true,
    component: ShopView
  },
]

const router = new VueRouter({
  routes
})

export default router
